import { BaseMutations } from '@/store/base-mutations';
import { EventsCalendar } from '../types';
import EventsCalendarState from './state';

export default class EventsCalendarMutations extends BaseMutations<EventsCalendarState> {
  SET_EVENTS(events: EventsCalendar.EventsCalendarItem[]) {
    this.state.events = events;
  }

  SET_EVENTS_CALENDAR(events: EventsCalendar.MapEvent[]) {
    this.state.events_format = events;
  }

  SET_SEARCH_EVENTS(events: EventsCalendar.MapEvent[]) {
    this.state.search_events = events;
  }

  UPD_FILTERS_KEY({ key, value }: { key: keyof EventsCalendar.EventsCalendarFilters; value: unknown }) {
    this.state.filters[key] = value;
  }

  UPD_FOCUS_DATE(date: string) {
    this.state.focus_date = date;
  }
}
